import * as React from "react";
import { InfoTooltip } from "@/ui/atoms/InfoTooltip";
import { Label } from "@/ui/atoms/Label";
import { ErrorMessage } from "@/ui/atoms/ErrorMessage";
import { cn } from "@/utils/utils";

export interface TFormFieldProps {
    label: string;
    htmlFor?: string;
    error?: string;
    required?: boolean;
    description?: string;
    /** Explanatory tooltip content rendered as an ⓘ icon next to the label */
    info?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export function FormField({
    label,
    htmlFor,
    error,
    required,
    description,
    info,
    children,
    className,
}: TFormFieldProps) {
    return (
        <div className={cn("space-y-2", className)}>
            <Label htmlFor={htmlFor}>
                {label}
                {required && <span className="text-destructive ml-1">*</span>}
                {info && <InfoTooltip content={info} className="ml-1.5" />}
            </Label>
            {children}
            {description && !error && (
                <p className="text-sm text-muted-foreground">{description}</p>
            )}
            {error && <ErrorMessage message={error} />}
        </div>
    );
}
